import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {withTranslation, WithTranslation} from "react-i18next";
const {Form, FormActions, FormBody} = form;

/**
 * Formulář pro tvorbu/úpravu ceníku.
 */
class CenikForm extends Component<WithTranslation> {

    static formName = 'CenikForm';

    render() {
        const {onClose, submitting, handleSubmit, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.String
                    autocomplete={'off'}
                    label={t('labels.name')}
                    name="nazevCenik"
                    disabled={submitting}
                />
                <ff.SimpleDate
                    autocomplete={'off'}
                    label={t('active_from')}
                    name="aktivniOd"
                    disabled={submitting}
                />
                <ff.SimpleDate
                    autocomplete={'off'}
                    label={t('active_to')}
                    name="aktivniDo"
                    disabled={submitting}
                />
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

export default withTranslation()(connect()(reduxForm({
    form: CenikForm.formName,
})(CenikForm)));
